import { PayloadAction, createSlice } from '@reduxjs/toolkit';

interface StaffType {
  id: string;
  name: string;
}

interface StaffTypeState {
  staffTypes: StaffType[];
}

const initialState: StaffTypeState = {
  staffTypes: [],
};

const staffTypeSlice = createSlice({
  name: 'staffType',
  initialState,
  reducers: {
    setStaffTypesAction(state, action: PayloadAction<StaffType[]>) {
      state.staffTypes = action.payload;
    },
    createStaffTypeAction(state, action: PayloadAction<StaffType>) {
      state.staffTypes.push(action.payload);
    },
    updateStaffTypeAction(state, action: PayloadAction<{ id: string; name: string }>) {
      const staffType = state.staffTypes.find(type => type.id === action.payload.id);
      if (staffType) {
        staffType.name = action.payload.name;
      }
    },
    deleteStaffTypeAction(state, action: PayloadAction<string>) {
      state.staffTypes = state.staffTypes.filter(type => type.id !== action.payload);
    },
  },
});

export const { setStaffTypesAction, createStaffTypeAction, updateStaffTypeAction, deleteStaffTypeAction } = staffTypeSlice.actions;

export default staffTypeSlice.reducer;
